module.exports = __webpack_public_path__ + "img/ico_thirdparty_facebookmessanger.83c1e2f5.png";